/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Metadata_Views_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to load metadata views: {error}" |
*
* @param {Iconik_Metadata_Views_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_views_error = /** @type {((inputs: Iconik_Metadata_Views_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Views_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Unable to load metadata views: ${i?.error}`)
});